export default "__VITE_ASSET__Vt8iWRol__"